<template>
  <v-card class="mx-auto" v-if="slides && slides.length > 0" flat max-width="700px">
    <v-carousel
      :show-arrows="false"
      hide-delimiter-background
      :hide-delimiters="!(slides.length > 1)"
      cycle
      class="rounded-lg carouselClass"
      vertical-delimiters="right"
      vertical
      height="auto">
      <v-carousel-item
        @click="openLink(slide)"
        v-for="(slide, i) of slides"
        :key="i + '-slide'"
        cover
        aspect-ratio="2.94"
        :src="'/img/' + slide.image"></v-carousel-item>
    </v-carousel>
  </v-card>
</template>

<script>
import api from "../../api"
import socketService from "@/socketService"

export default {
  name: "diverseSlider",

  data() {
    return {
      loading: true,
      slides: [],
    }
  },

  async created() {
    this.setupSocketListeners()
    this.slides = [...(await api.fetchEventsForSlider()), ...(await api.fetchMainSlider())]
    this.loading = false
  },

  beforeDestroy() {
    // Clean up BOTH listeners to prevent memory leaks
    socketService.off("slide_changed")
    socketService.off("slide_created")
  },

  methods: {
    setupSocketListeners() {
      // Remove previous listeners
      socketService.off("slide_changed")
      socketService.off("slide_created")

      // Set up listeners for BOTH events. They can share the same handler logic.
      socketService.on("slide_changed", (data) => {
        if (data.slide) this.handleSlideUpdate(data.slide)
      })

      socketService.on("slide_created", (data) => {
        if (data.slide) this.handleSlideUpdate(data.slide)
      })
    },

    // A single, robust function to handle all slide updates
    handleSlideUpdate(slide) {
      const now = this.$moment()
      const showAfter = this.$moment(slide.showAfter)
      const hideAfter = this.$moment(slide.hideAfter).endOf("day")

      // 1. Determine if the slide should be currently visible
      const isActive = now.isSameOrAfter(showAfter) && now.isSameOrBefore(hideAfter)

      // 2. Find the slide's current position in the array
      const index = this.slides.findIndex((s) => s._id === slide._id)
      const slideExists = index !== -1

      if (slideExists) {
        if (isActive) {
          // Case 1: The slide exists and is active -> UPDATE IT
          console.log("Slide updated:", slide.title)
          // Use Vue.set or splice to ensure reactivity
          this.$set(this.slides, index, slide)
        } else {
          // Case 2: The slide exists but is no longer active -> REMOVE IT
          console.log("Slide removed (expired/inactive):", slide.title)
          this.slides.splice(index, 1)
        }
      } else {
        if (isActive) {
          // Case 3: The slide is new and is active -> ADD IT
          console.log("New slide added:", slide.title)
          this.slides.push(slide)
        }
        // Case 4 (implicit): The slide is new but not active -> DO NOTHING
      }
    },

    openLink(slide) {
      let link = slide.link || null
      if (link) {
        if (link.includes("http://") || link.includes("https://")) {
          window.open(link, "_blank").focus()
        } else {
          this.$router.push(link)
        }
      }
    },
  },
}
</script>
